import { Center, HStack, Text } from '@rbilabs/universal-components';

import { getDesignToken, primitive, spacing } from 'styles/constants';
export const Container = HStack.withConfig({
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: spacing.$2_5,
  space: '$5',
});

export const BadgeWrapper = Center.withConfig<{ $orange: boolean }>(p => ({
  backgroundColor: p.$orange
    ? getDesignToken('alert-info-background')
    : getDesignToken('alert-success-background'),
  minWidth: '$20',
  height: '$5',
  borderRadius: '5px',
  paddingY: spacing.$0_5,
  paddingX: '$0',
}));

export const Badge = Text.withConfig({
  fontSize: 'xs',
  lineHeight: 'xs',
  textAlign: 'center',
  fontFamily: 'heading',
  color: primitive.$mayoEggWhite,
});

export const displayValueStyleProps = () => ({
  background: 'transparent',
  height: '$8',
  minWidth: '$8',
  width: '$8',
});

export const incrementorStyleProps = ({ disabled }: { disabled?: boolean }) => ({
  padding: '$0',
  borderRadius: 'full',
  borderWidth: '2',
  borderColor: getDesignToken(disabled ? 'icon-disabled' : 'text-default'),
  _icon: {
    size: 'xs',
    borderColor: getDesignToken(disabled ? 'icon-disabled' : 'text-default'),
    color: getDesignToken(disabled ? 'icon-disabled' : 'text-default'),
  },
});
